<!--
**** IanOS App | IanOS Solution Project ****
**** Copyright 2025 ****
-->

<div class="product-top-filter bg-white rounded-3 shadow-sm mb-3" 
     style="border: 1px solid rgba(0,0,0,0.08); backdrop-filter: blur(10px);">
    <div class="row">
        <div class="col-12">
            <div class="product-filter-content p-3 d-flex flex-wrap align-items-center justify-content-between gap-3">
                
                <!-- Search Count -->
                <div class="search-count">
                    <h5 class="mb-0 d-flex align-items-center" 
                        style="font-size: 0.95rem; font-weight: 600; color: #495057;">
                        <span class="badge bg-light text-dark me-2 px-2 py-1 rounded-pill" 
                              style="font-size: 0.75rem; border: 1px solid #dee2e6;">
                            {{ products.length }}
                        </span>
                        de {{ paginate.totalItems }} productos
                    </h5>
                </div>

                <!-- Filter Controls Container -->
                <div class="filter-controls d-flex align-items-center flex-wrap" style="gap: 1.5rem;">
                    
                    <!-- View Toggle (Grid/List) -->
                    <div class="collection-view" style="flex-shrink: 0;">
                        <div class="btn-group" role="group" aria-label="Vista">
                            <button type="button" 
                                    class="btn btn-sm" 
                                    [class.btn-primary]="layoutView == 'grid-view'"
                                    [class.btn-outline-secondary]="layoutView != 'grid-view'"
                                    (click)="setLayoutView('grid-view')"
                                    style="font-size: 0.8rem; padding: 0.5rem 1rem; border-radius: 6px 0 0 6px;">
                                <i class="fa fa-th me-1"></i>
                                <span class="d-none d-lg-inline">Grilla</span>
                            </button>
                            <button type="button" 
                                    class="btn btn-sm"
                                    [class.btn-primary]="layoutView == 'list-view'"
                                    [class.btn-outline-secondary]="layoutView != 'list-view'"
                                    (click)="setLayoutView('list-view')"
                                    style="font-size: 0.8rem; padding: 0.5rem 1rem; border-radius: 0 6px 6px 0;">
                                <i class="fa fa-list-ul me-1"></i>
                                <span class="d-none d-lg-inline">Lista</span>
                            </button>
                        </div>
                    </div>

                    <!-- Separator -->
                    <div class="filter-separator d-none d-md-block" style="width: 50px; height: 30px; background: #dee2e6; margin: 0 0.5rem;"></div>

                    <!-- Grid Layout Options (only visible in grid view) 
                    <div class="collection-grid-view" *ngIf="layoutView == 'grid-view'" style="flex-shrink: 0;">
                        <div class="btn-group" role="group" aria-label="Columnas">
                            <button type="button" 
                                    class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                    [class.active]="grid == 'col-lg-6'"
                                    (click)="setGridLayout('col-lg-6')"
                                    style="width: 36px; height: 32px; font-size: 0.65rem; border-radius: 4px 0 0 4px; margin-right: 2px;"
                                    title="2 columnas">
                                <span class="grid-icon">⚏⚏</span>
                            </button>
                            <button type="button" 
                                    class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                    [class.active]="grid == 'col-lg-4'"
                                    (click)="setGridLayout('col-lg-4')"
                                    style="width: 36px; height: 32px; font-size: 0.65rem; margin-right: 2px;"
                                    title="3 columnas">
                                <span class="grid-icon">⚏⚏⚏</span>
                            </button>
                            <button type="button" 
                                    class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                    [class.active]="grid == 'col-lg-3'"
                                    (click)="setGridLayout('col-lg-3')"
                                    style="width: 36px; height: 32px; font-size: 0.65rem; margin-right: 2px;"
                                    title="4 columnas">
                                <span class="grid-icon">⚏⚏⚏⚏</span>
                            </button>
                            <button type="button" 
                                    class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                                    [class.active]="grid == 'col-lg-2'"
                                    (click)="setGridLayout('col-lg-2')"
                                    style="width: 36px; height: 32px; font-size: 0.65rem; border-radius: 0 4px 4px 0;"
                                    title="6 columnas">
                                <span class="grid-icon">⚏⚏⚏⚏⚏⚏</span>
                            </button>
                        </div>
                    </div> -->

                    <!-- Separator -->
                    <div class="filter-separator d-none d-md-block" style="width: 1px; height: 30px; background: #dee2e6; margin: 0 0.5rem;"></div>

                    <!-- Sort Dropdown -->
                    <div class="product-page-filter" style="flex-shrink: 0;">
                        <select class="form-select form-select-sm" 
                                (change)="sorting($event)"
                                style="min-width: 180px; max-width: 220px; font-size: 0.85rem; border: 1px solid #dee2e6; border-radius: 6px; padding: 0.5rem 1rem;">
                            <option value="">Ordenar por...</option>
                            <option value="a-z" [selected]="sortBy == 'a-z'">A-Z Alfabético</option>
                            <option value="z-a" [selected]="sortBy == 'z-a'">Z-A Alfabético</option>
                            <option value="low" [selected]="sortBy == 'low'">Precio: Menor a Mayor</option>
                            <option value="high" [selected]="sortBy == 'high'">Precio: Mayor a Menor</option>
                            <option value="newest" [selected]="sortBy == 'newest'">Más Recientes</option>
                            <option value="popular" [selected]="sortBy == 'popular'">Más Populares</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Enhanced CSS for the filter component -->
<style>
.product-top-filter {
    transition: all 0.3s ease;
}

.product-top-filter:hover {
    box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
}

.search-count .badge {
    background: linear-gradient(135deg, #ff6b6b 0%, #ffd93d 100%) !important;
    color: white !important;
    border: none !important;
    font-weight: 600;
}

.btn-group .btn {
    border-color: #dee2e6;
    transition: all 0.2s ease;
}

.btn-group .btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.btn-group .btn.active {
    background: linear-gradient(135deg, #ff6b6b 0%, #ffd93d 100%);
    border-color: #ff6b6b;
    color: white;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.btn-primary {
    background: linear-gradient(135deg, #ff6b6b 0%, #ffd93d 100%) !important;
    border-color: #ff6b6b !important;
    box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.form-select {
    border: 1px solid #dee2e6;
    transition: all 0.2s ease;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e");
}

.form-select:focus {
    border-color: #ff6b6b;
    box-shadow: 0 0 0 0.2rem rgba(255, 107, 107, 0.25);
}

.form-select:hover {
    border-color: #ff6b6b;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.grid-icon {
    font-size: 0.6rem;
    line-height: 1;
    letter-spacing: 1px;
}

.filter-controls {
    gap: 0.75rem;
}

.filter-controls {
    gap: 1.5rem !important;
}

.collection-view,
.collection-grid-view,
.product-page-filter {
    flex-shrink: 0;
}

.filter-separator {
    opacity: 1.9;
}

/* Grid button spacing */
.collection-grid-view .btn {
    margin-right: 2px;
}

.collection-grid-view .btn:last-child {
    margin-right: 0;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
    .product-filter-content {
        flex-direction: column;
        align-items: stretch !important;
        gap: 1.25rem !important;
        padding: 1rem !important;
    }
    
    .filter-controls {
        justify-content: center;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding: 0.5rem 0;
        gap: 1rem !important;
    }
    
    .filter-separator {
        display: none !important;
    }
    
    .search-count {
        text-align: center;
        order: -1;
    }
    
    .search-count h5 {
        justify-content: center;
        font-size: 0.9rem !important;
    }
    
    .form-select {
        min-width: 160px !important;
        max-width: 160px !important;
        font-size: 0.8rem !important;
        padding: 0.4rem 0.8rem !important;
    }
    
    .collection-view .btn,
    .collection-grid-view .btn {
        padding: 0.4rem 0.7rem !important;
        font-size: 0.75rem !important;
    }
    
    .collection-view .btn span,
    .collection-grid-view .btn span {
        display: none !important;
    }
    
    .collection-grid-view .btn {
        width: 32px !important;
        height: 30px !important;
        font-size: 0.6rem !important;
        margin-right: 1px !important;
    }
}

@media (max-width: 576px) {
    .product-filter-content {
        padding: 1rem !important;
        gap: 1rem !important;
    }
    
    .filter-controls {
        flex-direction: row;
        justify-content: space-around;
        flex-wrap: nowrap;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
        gap: 0.75rem !important;
        padding: 0.75rem 0;
    }
    
    .filter-controls::-webkit-scrollbar {
        display: none;
    }
    
    .collection-view,
    .collection-grid-view,
    .product-page-filter {
        flex-shrink: 0;
        min-width: fit-content;
    }
    
    .form-select {
        min-width: 140px !important;
        max-width: 140px !important;
        font-size: 0.75rem !important;
        padding: 0.35rem 0.6rem !important;
    }
    
    .collection-view .btn,
    .collection-grid-view .btn {
        padding: 0.3rem 0.6rem !important;
        font-size: 0.7rem !important;
    }
    
    .collection-grid-view .btn {
        width: 28px !important;
        height: 28px !important;
        font-size: 0.55rem !important;
        margin-right: 1px !important;
    }
    
    .search-count h5 {
        font-size: 0.85rem !important;
    }
    
    .search-count .badge {
        font-size: 0.7rem !important;
        padding: 0.2rem 0.5rem !important;
    }
}

@media (max-width: 480px) {
    .filter-controls {
        gap: 0.5rem !important;
        padding: 0.5rem 0;
    }
    
    .product-filter-content {
        padding: 0.75rem !important;
    }
    
    .form-select {
        min-width: 120px !important;
        max-width: 120px !important;
        font-size: 0.7rem !important;
        padding: 0.3rem 0.5rem !important;
    }
    
    .collection-view .btn,
    .collection-grid-view .btn {
        padding: 0.25rem 0.5rem !important;
        font-size: 0.65rem !important;
    }
    
    .collection-grid-view .btn {
        width: 26px !important;
        height: 26px !important;
        font-size: 0.5rem !important;
        margin-right: 1px !important;
    }
}
</style>